<template>
	<div class="message-box">
		<div class="message">
			<div class="message-doc">
				<van-image class="avatar" round width="56" height="56" :src="doctor.avatar | imgUrl"/>
				<div class="intro">
					<div class="intro-name">
						<span>{{ doctor.name }}</span>
						<span>/</span>
						<span>{{ doctor.jobTitle }}</span>
					</div>
					<div class="intro-hospital">{{ doctor.hospital }}{{ doctor.department }}</div>
				</div>
				<div class="message-content">
					<template>
						<div v-if="$route.query.type === 'Text'">
							{{ content }}
						</div>
						<div v-if="$route.query.type === 'Image'">
							<img @click="showBigImage=true" class="message-img" :src="content" alt="">
						</div>
					</template>
					
					<div class="arrow"></div>
				</div>
			</div>
		</div>
		<van-button @click="onCloseWindow" class="consult" type="info">再次咨询</van-button>
		<van-image-preview closeable v-model="showBigImage" :images="[content]">
			<template v-slot:index><span></span></template>
		</van-image-preview>
	</div>
</template>

<script>
/**
 * @file 医生消息查看
 * 只支持 信息、图片，（暂不支持语音）
 * $route.query.type 枚举：Text，Image,Audio （语音暂时不做）
 * $route.query.content text 内容
 * $route.query.docId 医生索引
 * */
export default {
	name: 'message',
	data() {
		return {
			content: '',
			showBigImage: false,
			doctor: {
				avatar: '',
				hospital: '',
				name: '',
				jobTitle: '',
				specialties: '',
				department: ''
			}
		}
	},
	mounted() {
		this.content = decodeURIComponent(this.$route.query.content)
		this.$fetch.getDoctorDetail(this.$route.query.docId).then((res) => {
			Object.assign(this.doctor, res)
		})
	},
	methods: {
		onCloseWindow() {
			window.wx.closeWindow();
		}
	}
};
</script>

<style lang="scss" scoped>
	.message-box {
		position: relative;
		padding: 0 12px 44px 12px;
		height: 100vh;
		background: #fff;
		display: flex;
	}
	
	.message {
		overflow: auto;
		position: relative;
		padding-bottom: 12px;
		padding-top: 12px;
		flex: 1;
		.avatar {
			position: absolute;
			top: 12px;
			left: 0;
			width:56px;
			height:56px;
			border-radius:50px;
			background-color: #EDF4FF;
			background-size: cover;
			background-position: center;
		}
		.intro {
			width: 100%;
			padding: 12px 0 12px 64px;
			min-height: 96px;
			background:linear-gradient(180deg,rgba(245,249,255,1) 0%,rgba(245,249,255,0.09) 100%,rgba(245,249,255,0) 100%);
			border-radius: 12px;
			line-height: 1em;
			font-size: 15px;
			font-weight: 400;
		}
		.intro-name {
			margin-bottom: 12px;
			vertical-align: bottom;
			color: #35383D;
			span:first-of-type {
				font-weight: bold;
				font-size: 18px;
			}
			span:nth-of-type(2) {
				margin: 0 2px;
			}
		}
		.intro-hospital {
			color: #8C95A3;
		}
	}
	
	.consult {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
	}
	
	.message-doc {
		padding: 14px 12px 0 12px;
	}
	
	.message-content {
		position: relative;
		box-shadow: 0px 4px 16px 0px rgba(210,225,248,0.2), 0px -4px 16px 0px rgba(210,225,248,0.4);
		padding: 32px 12px;
		margin-top: -26px;
		font-size:16px;
		font-weight:400;
		line-height:24px;
		color: #333333;
		&::before, &::after {
			display: block;
			position: absolute;
			color: #999;
			font-family:LucidaGrande;
			font-size: 28px;
		}
		&::before {
			top: 12px;
			left: 12px;
			content: '“';
		}
		&::after {
			bottom: 4px;
			right: 12px;
			content: '”';
		}
		
		.arrow {
			position: absolute;
			border: 10px solid ;
			border-color: transparent transparent #fff #fff;
			top: -16px;
		}
	}
	.message-img {
		max-width: 100%;
	}
</style>
